<template>
  <v-card class="rounded-card card-shadow">
    <v-card-title class="font-weight-bold">
      Regra #{{ numeroRegra }}
    </v-card-title>
    <v-card-text class="text--primary--color">
      <template v-for="(criterio, index) in regra.criterios">
        <px-alcada-criterio :criterio="criterio"
                            :opcoes-criterios="opcoesCriterios"
                            :criterios-enum="criteriosEnum"
                            :key="criterio.$$id"
                            ref="criterios"
                            @remove="onRemoveCriterio(index)"/>
        <div v-if="!isLastCriterio(index)"
             :key="`${criterio.$$id}-e`"
             class="text-center">
          E
        </div>
      </template>
      <v-row dense>
        <v-col cols="12" class="text-right">
          <v-btn small
                 class="rounded-tag-small normal-btn-text elevation-0"
                 color="primary"
                 @click="onClickAdd">
            <v-icon small>mdi-plus</v-icon>
            Critério
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import AlcadaCriterio from '@/modules/alcadas/components/AlcadaCriterio.vue';
import { initalStateCriterio } from '@/modules/alcadas/components/alcadas-utils';

export default {
  props: {
    opcoesCriterios: Array,
    numeroRegra: Number,
    regra: {
      type: Object,
      required: true,
    },
    criteriosEnum: Array,
  },
  computed: {
    isLastCriterio() {
      return index => index === this.regra.criterios.length - 1;
    },
  },
  methods: {
    onClickAdd() {
      this.regra.criterios.push(initalStateCriterio());
    },
    onRemoveCriterio(index) {
      if (this.regra.criterios.length === 1) {
        return;
      }
      this.regra.criterios.splice(index, 1);
    },
    isValid() {
      return this.$refs.criterios.every(criterio => criterio.isValid());
    },
  },
  components: {
    pxAlcadaCriterio: AlcadaCriterio,
  },
};
</script>
